import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { getEndpoint } from 'src/app/core/services/functions.service';

export interface TipoNovedad {
  id?: number;
  codigo: string;
  tipo: string;
  descripcion: string;
  apartir_de: number;
  estado?: string;
}

export interface TipoNovedadOption {
  codigo: string;
  descripcion: string;
}

@Injectable({
  providedIn: 'root'
})
export class TipoNovedadService {
  ENDPOINT = getEndpoint('coms_tipo_novedad_comision');

  constructor(private http: HttpClient) { }

  getTiposNovedadActivos(company: string): Observable<TipoNovedadOption[]> {
    return this.http.get<TipoNovedad[]>(this.ENDPOINT, {
      headers: { 'company': company }
    })
      .pipe(
        map(novedades => novedades
          .filter(novedad => novedad.estado === 'ACTIVO')
          .map(novedad => ({
            codigo: novedad.codigo,
            descripcion: `${novedad.codigo} - ${novedad.descripcion}`
          }))
        )
      );
  }
}
